// extracted by mini-css-extract-plugin
module.exports = {"container":"PinLevelPermissionCheckboxList_container__3oLIT","permission":"PinLevelPermissionCheckboxList_permission__1GjRo"};